module.exports = __webpack_public_path__ + "img/italy-male.6d825aa6.png";